import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Slider } from '@mui/material';

PeriodRangeSlider.propTypes = {
  currentPeriod: PropTypes.object,
  sliderType: PropTypes.string,
  valueLabelDisplay: PropTypes.string,
  publishedPeriods: PropTypes.array,
  setCurrentPeriod: PropTypes.func,
  disabled: PropTypes.bool
};

const setDefaultPeriodValue = (publishedPeriods, sliderType, currentPeriod) => {
  let defaultPeriodValue = {};
  if (currentPeriod === undefined) {
    if (sliderType === 'Single') {
      defaultPeriodValue = [publishedPeriods.length];
    } else {
      defaultPeriodValue = [publishedPeriods.length - process.env.REACT_APP_NUM_PERIODS, publishedPeriods.length];
    }
  } else {
    const startIndex =
      publishedPeriods.findIndex(
        (period) => period.startDate === currentPeriod.start.startDate && period.endDate === currentPeriod.start.endDate
      ) + 1;
    if (sliderType === 'Single') {
      defaultPeriodValue = [startIndex];
    } else {
      const endIndex =
        publishedPeriods.findIndex(
          (period) => period.startDate === currentPeriod.end.startDate && period.endDate === currentPeriod.end.endDate
        ) + 1;

      defaultPeriodValue = [startIndex, endIndex];
    }
  }
  return defaultPeriodValue;
};

export default function PeriodRangeSlider({
  sliderType,
  valueLabelDisplay,
  publishedPeriods,
  setCurrentPeriod,
  currentPeriod,
  disabled = false
}) {
  const [value, setValue] = useState([]);
  const [valueLabelSX, setValueLabelSX] = useState({
    marginLeft: 1,
    marginRight: 1,
    width: 'calc(100% - 16px)',
    '& .MuiSlider-markLabel': {
      color: 'primary.contrastText',
      fontSize: '0.75rem'
    }
  });

  const handlePeriodCommit = (event, newValue) => {
    const periodStart = publishedPeriods[newValue[0] - 1];
    const periodEnd = publishedPeriods[newValue[1] - 1];

    setCurrentPeriod({
      start: periodStart,
      end: sliderType === 'Single' ? periodStart : periodEnd
    });
  };

  const handlePeriodChange = (event, newValue) => {
    setValue(newValue);
  };

  const sdfsdfsdf = (sliderType, value) => {
    let sx = {};
    if (sliderType === 'Single') {
      if (value[0] === 1) {
        sx = {
          '&.MuiSlider-root .MuiSlider-thumb[data-index="0"] .MuiSlider-valueLabel': {
            marginLeft: '110px',
            '&::before': {
              left: '12px'
            }
          }
        };
      } else if (value[0] === publishedPeriods.length) {
        sx = {
          '&.MuiSlider-root .MuiSlider-thumb[data-index="0"] .MuiSlider-valueLabel': {
            marginRight: '110px',
            '&::before': {
              left: 'calc(100% - 12px)'
            }
          }
        };
      } else {
        sx = {
          '&.MuiSlider-root .MuiSlider-thumb[data-index="0"] .MuiSlider-valueLabel': undefined
        };
      }
    } else if (sliderType === 'Range') {
      if (value[0] === 1 && value[1] === publishedPeriods.length) {
        sx = {
          '&.MuiSlider-root .MuiSlider-thumb[data-index="0"] .MuiSlider-valueLabel': {
            marginLeft: '110px',
            '&::before': {
              left: '12px'
            }
          },
          '&.MuiSlider-root .MuiSlider-thumb[data-index="1"] .MuiSlider-valueLabel': {
            marginRight: '110px',
            '&::before': {
              left: 'calc(100% - 12px)'
            }
          }
        };
      } else if (value[0] !== value[1] && value[0] === 1 && value[1] !== publishedPeriods.length) {
        sx = {
          '&.MuiSlider-root .MuiSlider-thumb[data-index="0"] .MuiSlider-valueLabel': {
            marginLeft: '110px',
            '&::before': {
              left: '12px'
            }
          },
          '&.MuiSlider-root .MuiSlider-thumb[data-index="1"] .MuiSlider-valueLabel': undefined
        };
      } else if (value[0] !== value[1] && value[0] !== 1 && value[1] !== publishedPeriods.length) {
        sx = {
          '&.MuiSlider-root .MuiSlider-thumb[data-index="0"] .MuiSlider-valueLabel': undefined,
          '&.MuiSlider-root .MuiSlider-thumb[data-index="1"] .MuiSlider-valueLabel': undefined
        };
      } else if (value[0] !== value[1] && value[0] !== 1 && value[1] === publishedPeriods.length) {
        sx = {
          '&.MuiSlider-root .MuiSlider-thumb[data-index="0"] .MuiSlider-valueLabel': undefined,
          '&.MuiSlider-root .MuiSlider-thumb[data-index="1"] .MuiSlider-valueLabel': {
            marginRight: '110px',
            '&::before': {
              left: 'calc(100% - 12px)'
            }
          }
        };
      } else if (value[0] === value[1] && value[0] > 1 && value[1] < publishedPeriods.length) {
        sx = {
          '&.MuiSlider-root .MuiSlider-thumb[data-index="0"] .MuiSlider-valueLabel': undefined,
          '&.MuiSlider-root .MuiSlider-thumb[data-index="1"] .MuiSlider-valueLabel': undefined
        };
      } else if (value[0] === value[1] && value[0] === 1) {
        sx = {
          '&.MuiSlider-root .MuiSlider-thumb[data-index="0"] .MuiSlider-valueLabel': {
            marginLeft: '110px',
            '&::before': {
              left: '12px'
            }
          },
          '&.MuiSlider-root .MuiSlider-thumb[data-index="1"] .MuiSlider-valueLabel': {
            marginLeft: '110px',
            '&::before': {
              left: '12px'
            }
          }
        };
      } else if (value[0] === value[1] && value[1] === publishedPeriods.length) {
        sx = {
          '&.MuiSlider-root .MuiSlider-thumb[data-index="0"] .MuiSlider-valueLabel': {
            marginRight: '110px',
            '&::before': {
              left: 'calc(100% - 12px)'
            }
          },
          '&.MuiSlider-root .MuiSlider-thumb[data-index="1"] .MuiSlider-valueLabel': {
            marginRight: '110px',
            '&::before': {
              left: 'calc(100% - 12px)'
            }
          }
        };
      }
    }
    return sx;
  };

  useEffect(() => {
    setValue(setDefaultPeriodValue(publishedPeriods, sliderType, currentPeriod));
  }, [currentPeriod]); // eslint-disable-line

  useEffect(() => {
    setValueLabelSX({
      ...valueLabelSX,
      ...sdfsdfsdf(sliderType, value)
    });
  }, [value]); // eslint-disable-line

  return (
    publishedPeriods !== undefined && (
      <>
        {/* <pre>{JSON.stringify(valueLabelSX, null, 2)}</pre> */}
        {/* <pre>{value[0]}</pre> */}
        {/* <pre>{value[value.length - 1]}</pre> */}
        {/* <pre>{publishedPeriods.length}</pre> */}
        <Slider
          disabled={disabled}
          size="medium"
          value={value}
          onChange={handlePeriodChange}
          onChangeCommitted={handlePeriodCommit}
          valueLabelDisplay={valueLabelDisplay === undefined ? 'on' : valueLabelDisplay}
          aria-labelledby="range-slider"
          valueLabelFormat={(v) => publishedPeriods?.find((p, i) => i + 1 === v)?.label || ''}
          max={publishedPeriods?.length || 1}
          min={1}
          marks={publishedPeriods?.map((pp, i) => ({
            value: i + 1
          }))}
          sx={valueLabelSX}
        />
      </>
    )
  );
}
